import request from '@utils/request';
import ApiHost from '@services/api-config';
import { AxiosPromise } from 'axios';
type UserInfo = {
	[propName: string]: string | number | boolean | { [propName: string]: string | number | undefined };
}

export const updateUserInfo = (data: UserInfo): AxiosPromise<RequestResponse<boolean>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/user/update/baseInfo`,
		data
	})
}

export const getOrderData = (data: { pageNo: number; pageSize: number }): AxiosPromise<RequestResponse<any>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order`,
		data
	})
}

export const getPayUrl = (data: { orderNo: string | undefined; orderPaymentNo: string | undefined }): AxiosPromise<RequestResponse<string>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order/get/pay/url`,
		data
	})
}

/**
 * 获取trustpilot值
*/
export function getTrustpilot () {
	return request ({
		method: 'get',
		url: `${ApiHost.airGateway}/ac-ops-third-api/api/trust/score`
	})
}
